import { fetchTamdaGroupSetting } from "@/services/tamdaGroupSetting"
import { TamdaGroupAttributes } from "@/types/types"
import { create } from "zustand"

export interface FooterSettings {
  hotline?: string
  address?: string
  email?: string
  facebookUrl?: string
  twitterUrl?: string
  youtubeUrl?: string
  googleMapUrl?: string | null
  copyright?: string
}

interface FooterSettingsState {
  settings: FooterSettings | null
  loading: boolean
  error: Error | null
  isFetching: boolean
  fetchSettings: (locale: string) => Promise<void>
  locale: string | null
}

export const useFooterSettingsStore = create<FooterSettingsState>(set => ({
  settings: null,
  loading: false,
  error: null,
  isFetching: false,
  locale: null,

  fetchSettings: async (locale: string) => {
    const currentState = useFooterSettingsStore.getState()

    if (currentState.isFetching && currentState.locale === locale) {
      return
    }

    if (currentState.locale !== locale) {
      set({ settings: null, locale: locale })
    }

    if (currentState.settings || currentState.isFetching) {
      return
    }

    try {
      set({ isFetching: true, loading: true, error: null })

      const apiData = await fetchTamdaGroupSetting(locale)

      if (apiData?.attributes) {
        const attributes = apiData.attributes as TamdaGroupAttributes
        set({
          settings: {
            hotline: attributes.hotline,
            address: attributes.address,
            email: attributes.email,
            facebookUrl: attributes.facebookUrl,
            twitterUrl: attributes.twitterUrl,
            youtubeUrl: attributes.youtubeUrl,
            googleMapUrl: attributes.googleMapUrl,
            copyright: attributes.copyright,
          },
          loading: false,
          isFetching: false,
          locale: locale,
        })
      } else {
        set({ loading: false, isFetching: false, locale: locale })
      }
    } catch (error) {
      console.error("Failed to load footer settings:", error)
      set({
        error: error instanceof Error ? error : new Error("Unknown error"),
        loading: false,
        isFetching: false,
        locale: locale,
      })
    }
  },
}))
